module.exports = __webpack_public_path__ + "media/images/common/limited_product_menu-7f7e48069aaad20f4dbf59ea7c84cd3a.png";